import {createAction, createReducer} from "@reduxjs/toolkit";


export const showLoader = createAction<boolean>('loader/show');
export const hideLoader = createAction<boolean>('loader/hide');

export default createReducer(false, (builder) => {
  builder.addCase(showLoader, (state, action) => true)
  builder.addCase(hideLoader, (state, action) => false)
});